<template>
  <div>
    <div class="panel-heading" style="display:flex; justify-content:space-between; align-items:center;">
      <h4 class="panel-title">{{ $t('reports.dailyRevenueReportTitle') }}</h4>
      <img src="../../../assets/images/black_shipzone.png" class="print-only" style="height:40px;" alt="Lasshopping" />
    </div>
    <div class="panel-body" style="display: block">
      <div class="row mb-3 no-print">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
          <date-picker
            style="margin-top: 4%; border-bottom-color: #919191"
            :date="startTime"
            :option="fromOption"
            class="form-control"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
          <date-picker
            style="margin-top: 4%; border-bottom-color: #919191"
            :date="endTime"
            :option="toOption"
            class="form-control"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4" style="display:flex; align-items:center; flex-wrap:nowrap; gap:8px;">
          <v-btn style="height: auto" @click="getData()" depressed :loading="loading">
            &nbsp; {{ $t('reports.apply') }}
          </v-btn>
          <v-btn v-if="rows.length" class="no-print" @click="printReport()" color="blue-grey" dark small style="height:auto;">
            <v-icon left small>print</v-icon> {{ $t('reports.printReport') }}
          </v-btn>
          <p v-if="rows.length" class="print-only"><strong>{{ $t('reports.periodColon') }} {{ startTime.time }} &mdash; {{ endTime.time }}</strong></p>
        </div>
      </div>

      <table v-if="rows.length" class="table table-bordered daily-revenue-table">
        <thead style="background-color:#4A8AF4; color:#fff;">
          <tr>
            <th>#</th>
            <th>{{ $t('common.date') }}<span class="col-sub">{{ $t('reports.orderDateHint') }}</span></th>
            <th>{{ $t('reports.request') }}<span class="col-sub">{{ $t('reports.orderRequestIdHint') }}</span></th>
            <th>{{ $t('columns.price') }}<span class="col-sub"><b>P</b> {{ $t('reports.equalsItemPriceLocalCurrency') }}</span></th>
            <th>{{ $t('columns.currency') }}<span class="col-sub">{{ $t('reports.currencyOfPHint') }}</span></th>
            <th>{{ $t('columns.quantity') }}<span class="col-sub"><b>Q</b> {{ $t('reports.equalsUnitsOnOrder') }}</span></th>
            <th>USD<span class="col-sub"><b>A</b> {{ $t('reports.equalsBuyCostUsd') }}</span></th>
            <th>{{ $t('reports.exchangeDifference') }}<span class="col-sub"><b>B</b> {{ $t('reports.equalsPerUnitExchangeMargin') }}</span></th>
            <th>{{ $t('reports.shippingCost') }}<span class="col-sub"><b>C</b> {{ $t('reports.equalsPerUnitShippingCost') }}</span></th>
            <th>{{ $t('reports.deliveryIqd') }}<span class="col-sub"><b>D</b> {{ $t('reports.equalsDeliveryFeeIqd') }}</span></th>
            <th>{{ $t('reports.totalGain') }}<span class="col-sub"><b>E</b> {{ $t('reports.equalsRowGainApprox') }}</span></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in rows" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.order_date }}</td>
            <td>{{ item.theOrderID }}</td>
            <td>{{ fmt(item.local_price) }}</td>
            <td :style="{ color: item.currency_symbol === '$' ? 'red' : 'blue', fontWeight: 'bold' }">
              {{ item.currency_symbol }}
            </td>
            <td>{{ item.quantity }}</td>
            <td>{{ fmt(item.buy_cost) }}</td>
            <td>
              <span v-if="item.quantity > 1">
                {{ fmt(item.exchange_diff) }} <span style="color:red;font-weight:bold;">X</span> {{ item.quantity }}
              </span>
              <span v-else>{{ fmt(item.exchange_diff) }}</span>
            </td>
            <td>
              <span v-if="item.quantity > 1">
                {{ fmt(item.shipping) }} <span style="color:red;font-weight:bold;">X</span> {{ item.quantity }}
              </span>
              <span v-else>{{ fmt(item.shipping) }}</span>
            </td>
            <td>{{ fmtIqd(item.delivery_iqd) }}</td>
            <td style="font-weight:bold;">{{ fmt(item.total_gain) }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr style="background-color:#e9f5b7; font-weight:bold;">
            <td colspan="7">{{ $t('reports.totalRevenueFooterLabel') }} <span class="col-sub" style="opacity:1;">{{ $t('reports.totalRevenueAcrossRowsHint') }}</span></td>
            <td><strong style="color:blue;">{{ fmt(totals.total_exchange_diff) }}</strong> $</td>
            <td><strong style="color:blue;">{{ fmt(totals.total_shipping) }}</strong> $</td>
            <td><strong style="color:blue;">{{ fmtIqd(totals.total_delivery_iqd) }}</strong> IQD</td>
            <td><strong style="color:blue;">{{ fmt(totals.total_gain) }}</strong> $</td>
          </tr>
          <tr>
            <td colspan="10" style="text-align:right;">{{ $t('reports.businessExpensesFooterLabel') }} <span class="col-sub" style="opacity:1;"><b>F</b> {{ $t('reports.equalsSigmaBusinessExpensesInPeriod') }}</span></td>
            <td><strong style="color:red;">-{{ fmt(totals.total_expenses) }}</strong> $</td>
          </tr>
          <tr style="background-color:#c8e6c9; font-weight:bold;">
            <td colspan="10" style="text-align:right;">{{ $t('reports.netGainAfterExpensesFooterLabel') }} <span class="col-sub" style="opacity:1;">&Sigma;E &minus; F</span></td>
            <td><strong style="color:green;">{{ fmt(totals.total_net_gain) }}</strong> $</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import myDatepicker from 'vue-datepicker'

export default {
  components: { 'date-picker': myDatepicker },
  data() {
    return {
      loading: false,
      rows: [],
      totals: {},
      startTime: { time: '' },
      endTime: { time: '' },
      headers: [
        { text: 'Date', value: 'order_date' },
        { text: 'Request', value: 'theOrderID' },
        { text: 'Price', value: 'local_price' },
        { text: 'Currency', value: 'currency_symbol' },
        { text: 'Quantity', value: 'quantity' },
        { text: 'USD', value: 'buy_cost' },
        { text: 'Exchange Difference', value: 'exchange_diff' },
        { text: 'Shipping Cost', value: 'shipping' },
        { text: 'Total Gain', value: 'total_gain' }
      ],
      fromOption: this.$_datepickerOption(this.$t('columns.fromDate')),
      toOption: this.$_datepickerOption(this.$t('columns.toDate'))
    }
  },
  mounted() {
    this.initCurrentMonth()
  },
  methods: {
    initCurrentMonth() {
      const now = new Date()
      const y = now.getFullYear()
      const m = String(now.getMonth() + 1).padStart(2, '0')
      const lastDay = new Date(y, now.getMonth() + 1, 0).getDate()
      this.startTime.time = `${y}-${m}-01`
      this.endTime.time = `${y}-${m}-${String(lastDay).padStart(2, '0')}`
    },
    getData() {
      if (!this.startTime.time || !this.endTime.time) {
        swal(this.$t('common.error'), this.$t('reports.pleaseSelectFromToDate'), 'error')
        return
      }
      this.loading = true
      const token = localStorage.getItem('access_token')
      axios
        .post('api/report/daily-revenue', { from_date: this.startTime.time, to_date: this.endTime.time }, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(res => {
          this.rows   = res.data.rows
          this.totals = res.data.totals
        })
        .catch(() => swal(this.$t('common.error'), this.$t('reports.failedToLoadReport'), 'error'))
        .finally(() => { this.loading = false })
    },
    fmt(v) {
      return parseFloat(v || 0).toFixed(2)
    },
    fmtIqd(v) {
      return Math.round(parseFloat(v || 0)).toLocaleString()
    },
    printReport() { window.print() },
    $_datepickerOption(placeholder) {
      return {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January','February','March','April','May','June','July','August','September','October','November','December'],
        format: 'YYYY-MM-DD',
        placeholder,
        inputStyle: { display: 'inline-block', padding: '6px', 'line-height': '22px', 'font-size': '16px', color: '#2d2d2d', width: '100%' },
        color: { header: '#80864D', headerText: '#ffffff' },
        overlayOpacity: 0.5,
        dismissible: true
      }
    }
  }
}
</script>

<style>
@media print {
  @page {
    margin: 8mm;
  }

  body, html {
    margin: 0 !important;
    padding: 0 !important;
  }

  .no-print {
    display: none !important;
  }

  .print-only {
    display: block !important;
  }

  .panel-heading,
  .panel-body {
    padding: 0 !important;
  }

  .table {
    width: 100% !important;
    table-layout: fixed !important;
    border-collapse: collapse !important;
    font-size: 8pt !important;
    word-break: break-word;
  }

  .table th,
  .table td {
    padding: 3px 4px !important;
    font-size: 8pt !important;
    overflow: hidden;
  }
}

.print-only {
  display: none;
}

.daily-revenue-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  font-size: 12px;
}

.daily-revenue-table th,
.daily-revenue-table td {
  padding: 6px 4px;
  word-break: break-word;
  overflow-wrap: break-word;
  vertical-align: middle;
}

.daily-revenue-table th:first-child,
.daily-revenue-table td:first-child {
  width: 3%;
}

@media (max-width: 992px) {
  .daily-revenue-table {
    font-size: 10px;
  }

  .daily-revenue-table .col-sub {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/dailyRevenueReport.vue